import React from "react";
import CardsNews from "../CardsNews/CardsNews";
import { Box, Container, Typography, Grid } from "@mui/material";
import useSectionView from "../hook/useSectionView";

const NEWS = [
  {
    title: "HOSPITALAR 2023",
    date: "Mayo, 2023",
    description:
      'Expusimos nuestro catálogo de productos en "Hospitalar", la principal feria del sector salud en América Latina en la São Paulo Expo de Brasil.\n¡Seguimos construyendo las bases para llevar nuestros productos a nuevos países!',
    image: "/assets/novedades/IMG_6418.jpeg",
    author: "H",
  },
  {
    title: "EXPOMEDICAL 2022",
    date: "Septiembre, 2022",
    description:
      "SERTEX participó como expositor en EXPOMEDICAL 2022, el mayor evento profesional para todo el equipo del Sector Salud de Argentina y los países hispanohablantes, donde más de 150 expositores nacionales e internacionales presentararon sus últimos lanzamientos de productos, tecnologías y servicios para hospitales, clínicas, laboratorios y consultorios.",
    image: "/assets/novedades/1.jpg",
    author: "E",
  },
];

const News = () => {
  const sectionRef = useSectionView("Novedades");

  return (
    <section id="Novedades" aria-labelledby="news-heading" ref={sectionRef}>
      <Box
        sx={{
          width: "100%",
          py: { xs: 2, md: 3 },
          backgroundImage: "linear-gradient(to right top,  #1d93d9, #27aaea)",
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            mt: { xs: 3, md: 5 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            id="news-heading"
            variant="h4"
            sx={{
              color: "#fff",
              fontWeight: 900,
              letterSpacing: { xs: "2px", md: "4px" },
              textAlign: "center",
              mb: 2,
            }}
          >
            Novedades
          </Typography>

          <Grid
            container
            spacing={2}
            alignItems="stretch"
            justifyContent="center"
            sx={{ mt: { xs: 1, md: 2 } }}
          >
            {NEWS.map((n) => (
              <Grid item xs={12} md={6} key={n.title} sx={{ display: "flex" }}>
                <Box sx={{ width: "100%" }}>
                  <CardsNews {...n} />
                </Box>
              </Grid>
            ))}
          </Grid>

          {/* CTA opcional */}
          {/*      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button
              variant="outlined"
              color="inherit"
              endIcon={<OpenInNewIcon />}
              href="/novedades"
              sx={{
                borderColor: "rgba(255,255,255,0.6)",
                color: "#fff",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
              }}
              aria-label="Ver todas las novedades"
            >
              Ver todas las novedades
            </Button>
          </Box> */}
        </Container>
      </Box>
    </section>
  );
};

export default News;
